import theme from '../../themes/green';

const styles = {
  wrapper: {
    display: 'flex',
    flexFlow: 'column nowrap',
    height: '100%',
    paddingTop: 20,
  },
  logoWrapper: {
    textAlign: 'center',
  },
  hr: {
    backgroundColor: theme.pallete.scrollbar,
  },
  project: {
    color: theme.pallete.lightTextColor,
    fontSize: 11,
    marginBottom: 0,
    lineHeight: 1.5,
    fontWeight: 600,
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    marginTop: 0,
    ':hover': {
      color: theme.pallete.background,
    },
    selected: {
      color: theme.pallete.background,
    },
  },
  addButton: {
    borderRadius: '50%',
    minWidth: 'inherit',
    background: 'transparent',
    opacity: 1,
    marginHorizontal: 10,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    width: 17,
    height: 17,
    ':hover': {
      background: 'transparent',
      opacity: 0.6,
    },
    label: {
      color: theme.pallete.color,
    },
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/AppDrawer/styles.js